import { FC } from 'react';
import { Skeleton } from '@/components/ui/skeleton';

type Props = {};

const NewOrderServiceSkeleton: FC<Props> = () => {
	return (
		<div className='flex items-center gap-4'>
			<Skeleton className='size-9 rounded-semi-xl' />
			<div>
				<div className='h-6 flex items-center'>
					<Skeleton className='h-3 w-30 rounded-full' />
				</div>
				<div className='h-5 flex items-center'>
					<Skeleton className='h-3 w-16 rounded-full' />
				</div>
			</div>
			<Skeleton className='size-8 ml-auto rounded-full' />
		</div>
	);
};

export default NewOrderServiceSkeleton;
